import React from 'react';
import EditableTable from './EditableTable';
import { TranslationData } from '../../services/translationService';

interface TranslationTableSectionProps {
  prefix: string;
  columns: any[];
  data: TranslationData[];
  getRowKey: (row: TranslationData) => string;
  getCellContent: (row: TranslationData, columnKey: string) => string;
  onCellChange: (rowKey: string, columnKey: string, value: string) => void;
  onDelete: (rowKey: string) => void;
  selectedRows: Set<string>;
  onRowSelect: (rowKey: string, selected: boolean) => void;
  onCellFocus: (rowKey: string, columnKey: string, content: string, sourceLanguage: string | null) => void;
  onCellBlur: () => void;
  onTranslate: (rowKey: string, columnKey: string, translatedText: string) => Promise<void>;
  onTranslateCell: (rowKey: string, columnKey: string, sourceText: string) => Promise<{ result: string; } | null>;
  targetLanguage: string;
  sourceLanguage: string | null;
  onTabNavigation: (direction: 'next' | 'previous', rowIndex: number, columnIndex: number) => void;
}

const TranslationTableSection: React.FC<TranslationTableSectionProps> = React.memo(({
  prefix,
  columns,
  data,
  getRowKey,
  getCellContent,
  onCellChange,
  onDelete,
  selectedRows,
  onRowSelect,
  onCellFocus,
  onCellBlur,
  onTranslate,
  onTranslateCell,
  targetLanguage,
  sourceLanguage,
  onTabNavigation
}) => {
  return (
    <div className="translations-group">
      <EditableTable
        columns={columns}
        data={data}
        getRowKey={getRowKey}
        getCellContent={getCellContent}
        onCellChange={onCellChange}
        onDelete={onDelete}
        selectedRows={selectedRows}
        onRowSelect={onRowSelect}
        onCellFocus={onCellFocus}
        onCellBlur={onCellBlur}
        onTranslate={onTranslate}
        onTranslateCell={onTranslateCell}
        targetLanguage={targetLanguage}
        sourceLanguage={sourceLanguage}
        onTabNavigation={onTabNavigation}
      />
    </div>
  );
}, (prevProps, nextProps) => {
  // Strict comparison function - only re-render if critical props changed
  return (
    prevProps.prefix === nextProps.prefix &&
    prevProps.data === nextProps.data &&
    prevProps.selectedRows === nextProps.selectedRows &&
    prevProps.targetLanguage === nextProps.targetLanguage &&
    prevProps.sourceLanguage === nextProps.sourceLanguage
  );
});

export default TranslationTableSection;
